import React from 'react';
import { Lead, EligibilityStatus } from '../types';
import { LeadRow } from './LeadRow';
interface LeadTableProps {
  leads: Lead[];
  onViewDetails: (lead: Lead, eligibility: EligibilityStatus) => void;
  onAction: (leadId: string, action: 'send' | 'cancel') => void;
}
export function LeadTable({
  leads,
  onViewDetails,
  onAction
}: LeadTableProps) {
  if (leads.length === 0) {
    return <div className="p-12 text-center" data-id="element-113">
        <h3 className="text-sm font-medium text-gray-900" data-id="element-114">
          No pending leads found
        </h3>
        <p className="mt-1 text-sm text-gray-500" data-id="element-115">
          Try adjusting your filters or search query.
        </p>
      </div>;
  }
  return <div className="overflow-x-auto" data-id="element-116">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-117">
        <thead className="bg-gray-50/50" data-id="element-118">
          <tr data-id="element-119">
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-120">
              Lead Details
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-121">
              Source
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-122">
              Owner
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-123">
              Status
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-124">
              Time Remaining
            </th>
            <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-125">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-100" data-id="element-126">
          {leads.map(lead => <LeadRow key={lead.id} lead={lead} onViewDetails={onViewDetails} onAction={onAction} data-id="element-127" />)}
        </tbody>
      </table>
    </div>;
}